/* eslint-disable react-hooks/exhaustive-deps */
import { forEach, get } from 'lodash';
import React, { useEffect, useState } from 'react';
import { scrapingFinanaces, scrapingFinanacesAll } from '../../../../apis/finances/auth';
import Form from '../../../../components/Form';
import Modal, { ModalHeader } from '../../../../components/Modal';
import { ORG_CD_TYPE } from '../../../../constants/SCRAPING_DATA';
import useForm from '../../../../hooks/useForm';
import { cardName } from '../../../../utils/account-name';
import { dateToFormat, diffDays, getDay, getFutureMonth } from '../../../../utils/date';
import { viewLoading } from '../../../../utils/loading';
import { isEmpty } from '../../../../utils/lodashExtend';
import systemAlert from '../../../../utils/systemAlert';
import { toast } from '../../../../utils/toast';
import { translation } from '../../../../utils/translator';

const getSelectFieldItem = orgCd => {
  let item = {};
  let defaultValue = "";

  switch (orgCd) {
    case 'hometax':
      item = {
        title: '서비스',
        key: 'svcCd',
        type: 'select',
        options: {
          list: [
            // { label: '매입 계산서 내역', value: "Z3004" },
            // { label: '매출 계산서 내역', value: "Z3003" },
            // { label: '매입 세금 계산서 내역', value: "Z3002" },
            // { label: '매출 세금 계산서 내역', value: "Z3001" },
            { label: '전체', value: "electronic-all" },
            { label: '전자 (세금)계산서 내역', value: "electronic-invoice" },
            { label: '매입 현금영수증 내역', value: "Z4002" },
            { label: '매출 현금영수증 내역', value: "Z4001" },
          ]
        },
        required: true
      };
      defaultValue = "electronic-all";
      break;
    case 'cardsales':
      item = {
        title: '서비스',
        key: 'svcCd',
        type: 'select',
        options: {
          list: [
            { label: '매출 내역', value: "B0021" },
            { label: '입금 내역', value: "B0031" },
          ]
        },
        required: true
      };
      defaultValue = "B0021";
      break;
    case 'card':
    case 'ccd':
      item = {
        title: '서비스',
        key: 'svcCd',
        type: 'select',
        options: {
          list: [
            { label: '승인 내역', value: "C0005" },
          ]
        },
        required: true
      };
      defaultValue = "C0005";
      break;
    case 'pbk':
    case 'cbk':
      item = {
        title: '서비스',
        key: 'svcCd',
        type: 'select',
        options: {
          list: [
            { label: '승인 내역', value: "B0002" },
          ]
        },
        required: true
      };
      defaultValue = "B0002";
      break;
    default:
      break;
  }

  return { item, defaultValue };
};

const PassivityScrapingModal = ({
  isOpen,
  setIsOpen,
  scrapingData,
  submit, //스크래핑 될 때까지 수집이력 리스트 조회가 안되므로 submit 의미가 없는 듯 함
  orgCd,
  type = "",
  reload,
}) => {
  const { item, defaultValue } = getSelectFieldItem(orgCd);
  const [fields, setFields] = useState([]);

  const _submit = (form) => {
    if (type === 'all') {
      // 전체 스크래핑
      const sdate = dateToFormat(form.date[0], 'YYYYMMDD');
      const edate = dateToFormat(form.date[1], 'YYYYMMDD');
      const maxDate = getFutureMonth(sdate, 2, 'YYYYMMDD');
      if (diffDays(maxDate, edate) > 0) return toast.error('조회 기간은 최대 2개월 입니다.');

      viewLoading(true);
      scrapingFinanacesAll({ sdate, edate })
        .then(() => {
          systemAlert(
            <>
              <p>스크래핑 요청에 성공하였습니다.</p>
              <p>스크래핑이 완료될 때까지 일정시간이 소요됩니다.</p>
              <p className="color-red-100">수집이력 내역 반영까지 일정시간이 소요됩니다.</p>
              <p>새로고침해 주세요.</p>
            </>
          );
          cancel();
          reload();
        })
        .finally(() => {
          viewLoading(false);
        });
    } else {
      // 부분 스크래핑
      const sdate = dateToFormat(form.date[0], 'YYYYMMDD');
      const edate = dateToFormat(form.date[1], 'YYYYMMDD');

      if (orgCd === 'cbk' || orgCd === 'pbk') {
        const maxDate = getFutureMonth(sdate, 2, 'YYYYMMDD');
        if (diffDays(maxDate, edate) > 0) return toast.error('조회 기간은 최대 2개월 입니다.');
      } else {
        const maxDate = getFutureMonth(sdate, 3, 'YYYYMMDD');
        if (diffDays(maxDate, edate) > 0) return toast.error('조회 기간은 최대 3개월 입니다.');
      }

      if (form.svcCd === "electronic-all" || form.svcCd === "electronic-invoice") {
        // 홈택스 전자(세금)계산서 내역
        const promiseList = [];
        const codeList = ["Z3004", "Z3003", "Z3002", "Z3001"];
        if (form.svcCd === "electronic-all") {
          codeList.push("Z4001");
          codeList.push("Z4002");
        }

        forEach(codeList, code => {
          promiseList.push(scrapingFinanaces(scrapingData.idx, {
            svcCd: code,
            sdate: dateToFormat(form.date[0], 'YYYYMMDD'),
            edate: dateToFormat(form.date[1], 'YYYYMMDD')
          }));
        });
        viewLoading(true);
        Promise.all(promiseList)
          .then(() => {
            systemAlert(
              <>
                <p>스크래핑 요청에 성공하였습니다.</p>
                <p>스크래핑이 완료될 때까지 일정시간이 소요됩니다.</p>
                <p className="color-red-100">수집이력 내역 반영까지 일정시간이 소요됩니다.</p>
                <p>새로고침해 주세요.</p>
              </>
              , {
                buttons: [
                  {
                    label: '확인',
                    onClick: () => {
                      submit();
                      cancel();
                      reload();
                    }
                  },
                ]
              });
          })
          .catch(() => { })
          .finally(() => {
            viewLoading(false);
          });
      } else {
        // 나머지
        const body = {
          svcCd: form.svcCd,
          sdate: dateToFormat(form.date[0], 'YYYYMMDD'),
          edate: dateToFormat(form.date[1], 'YYYYMMDD')
        };

        viewLoading(true);
        scrapingFinanaces(scrapingData.idx, body)
          .then(() => {
            systemAlert(
              <>
                <p>스크래핑 요청에 성공하였습니다.</p>
                <p>스크래핑이 완료될 때까지 일정시간이 소요됩니다.</p>
                <p className="color-red-100">수집이력 내역 반영까지 일정시간이 소요됩니다.</p>
                <p>새로고침해 주세요.</p>
              </>
              , {
                buttons: [
                  {
                    label: '확인',
                    onClick: () => {
                      submit();
                      cancel();
                      reload();
                    }
                  },
                ]
              });
          })
          .catch(() => { })
          .finally(() => {
            viewLoading(false);
          });
      }
    }
  };

  const {
    form,
    errors,
    handleSubmit,
    handleOnChange,
    setValidateFields
  } = useForm(
    {
      svcCd: defaultValue,
      date: [getDay(7), getDay()]
    },
    _submit
  );

  useEffect(() => {
    if (type === 'all') {
      setFields([
        {
          title: '조회기간',
          key: 'date',
          type: 'customdatepicker',
          min: '2021-07-01',
          required: true,
        }
      ]);
    } else {
      setFields([
        item,
        {
          title: '조회기간',
          key: 'date',
          type: 'customdatepicker',
          required: true,
        }
      ]);
    }
  }, [form, type]);

  useEffect(() => {
    setValidateFields(fields);
  }, [isOpen, fields]);

  const cancel = () => {
    setIsOpen(false);
  };

  return (
    <Modal size="md" isOpen={isOpen} close={cancel}>
      <div className="passivity-scraping-wrap">
        <ModalHeader>
          {type === 'all' ? '전체 수동 스크래핑' : `${translation(ORG_CD_TYPE, orgCd)} 수동 스크래핑`}
          {!isEmpty(get(scrapingData, 'acctNm')) && <p className="sub-title">{`${scrapingData.acctNm}(${scrapingData.acctNo.substr(scrapingData.acctNo.length - 5)})`}</p>}
          {!isEmpty(get(scrapingData, 'cardNm')) && <p className="sub-title">{cardName(scrapingData.cardNm, scrapingData.cardNo)}</p>}
          {type === 'all' || orgCd === 'cbk' || orgCd === 'pbk' ? <p className="sub-title">조회기간을 최대 2개월 이내로 설정해주세요.</p> : <p className="sub-title">조회기간을 최대 3개월 이내로 설정해주세요.</p>}
        </ModalHeader>
        <Form
          fields={fields}
          form={form}
          onChange={handleOnChange}
          submit={handleSubmit}
          cancel={cancel}
          errors={errors}
        />
      </div>
    </Modal>
  );
};

export default PassivityScrapingModal;